import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class ComplaintAddition {
  list(page, limit, search, startDate, endDate, sortBy, sortType) {
    const params = {
      page: page,
      limit: limit,
      start_date: startDate,
      end_date: endDate,
    };

    if (sortBy) {
      params.sort_by = sortBy;
    }

    if (sortType) {
      params.sort_type = sortType;
    }

    if (search) {
      params.search = search;
    }

    const endPoint = `/worker/salary/addition/complaint?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  post(payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/complaint/posting`;
    return axios.post(url, payload, headersTokenConfig);
  }

  add(payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/complaint/add`;
    return axios.post(url, payload, headersTokenConfig);
  }

  edit(id, payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/complaint/${id}/edit`;
    return axios.put(url, payload, headersTokenConfig);
  }

  delete(id, itemId) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/complaint/${id}/remove/${itemId}`;
    return axios.delete(url, headersTokenConfig);
  }

  checklist(id, itemID, deductionMark) {
    const body = {
      item_id: itemID,
      mark: deductionMark,
    };

    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/addition/complaint/${id}/mark`;
    return axios.put(url, body, headersTokenConfig);
  }
}

export default new ComplaintAddition();
